import React from "react";
import styled from "styled-components";
import ChannelStatusBadge from "./ChannelStatusBadge";
import ChannelToggle from "./ChannelToggle";
import { LIVE_CHANNEL_ITEM_TOKENS } from "./liveChannelTokens";

const ItemRoot = styled.li`
  && {
    list-style: none;
    margin: 0;
    padding: 18px 0;
    border-top: 1px dashed ${({ $selected }) => ($selected ? LIVE_CHANNEL_ITEM_TOKENS.borderSelected : LIVE_CHANNEL_ITEM_TOKENS.border)};
    background: ${({ $selected }) => ($selected ? LIVE_CHANNEL_ITEM_TOKENS.backgroundSelected : LIVE_CHANNEL_ITEM_TOKENS.background)};
    opacity: ${({ $disabled }) => ($disabled ? 0.76 : 1)};
    box-sizing: border-box;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

const ItemStatusRow = styled.div`
  display: flex;
  align-items: center;
`;

const ItemTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
`;

const TitleButton = styled.button`
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${LIVE_CHANNEL_ITEM_TOKENS.title};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  cursor: pointer;

  &:hover {
    color: ${LIVE_CHANNEL_ITEM_TOKENS.actionHover};
  }
`;

const ItemActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`;

const ItemBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
`;

const ChannelIdText = styled.span`
  display: inline-block;
  min-width: 0;
  color: ${LIVE_CHANNEL_ITEM_TOKENS.channelId};
  font-size: 11px;
  line-height: 16px;
  word-break: break-all;
`;

const DetailButton = styled.button`
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${LIVE_CHANNEL_ITEM_TOKENS.action};
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  cursor: pointer;

  &:hover {
    color: ${LIVE_CHANNEL_ITEM_TOKENS.actionHover};
  }
`;

const TestStreamBadge = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 3px;
  background: rgba(89, 89, 239, 0.18);
  border: 1px solid rgba(165, 180, 252, 0.6);
  color: #a5b4fc;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
`;

export default function LiveChannelListItem({
  item,
  isSelected,
  isToggleable,
  isToggleChecked,
  isTestStreaming,
  onSelect,
  onToggle,
  onOpenDetail,
  detailLabel = "Channel Detail",
}) {
  const handleSelect = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSelect && onSelect(event);
  };

  const handleDetailOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenDetail && onOpenDetail(event);
  };

  return (
    <ItemRoot $selected={isSelected} $disabled={!isToggleable}>
      <ItemStatusRow>
        <ChannelStatusBadge status={item?.status} />
        {isTestStreaming && <TestStreamBadge>테스트 송출 중</TestStreamBadge>}
      </ItemStatusRow>
      <ItemTitleRow>
        <TitleButton type="button" onClick={handleSelect}>
          {item?.channelName || "-"}
        </TitleButton>
        <ItemActions>
          <ChannelToggle
            name={`live-channel-toggle-${item?.channelId || "unknown"}`}
            checked={isToggleChecked}
            disabled={!isToggleable}
            onChange={onToggle}
            ariaLabel={`${item?.channelName || "channel"} toggle`}
          />
        </ItemActions>
      </ItemTitleRow>
      <ItemBottom>
        <ChannelIdText>{item?.channelId || "-"}</ChannelIdText>
        <DetailButton type="button" onClick={handleDetailOpen}>
          {detailLabel}
        </DetailButton>
      </ItemBottom>
    </ItemRoot>
  );
}
